import { createRouter, createWebHistory } from 'vue-router'
import Settings from "@/components/Settings.vue";
import UserList from "@/components/UserList.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: UserList
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('@/components/Help.vue'),
      beforeEnter: (to, from, next) => {
        // Clean up existing Genesys instance if it exists
        // @ts-ignore
          if (window.Genesys) {
          try {
            // @ts-ignore
              window.Genesys("command", "Database.close");
            const existingScript = document.querySelector('script[src*="genesys-bootstrap"]');
            if (existingScript) {
              existingScript.remove();
            }
            // @ts-ignore
              delete window.Genesys;
          } catch (error) {
            console.log("Cleanup error:", error);
          }
        }
        next();
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    }
  ]
})

export default router